import { render, staticRenderFns } from "./pay-weixin-modal.vue?vue&type=template&id=af5899c6&scoped=true&"
import script from "./pay-weixin-modal.vue?vue&type=script&lang=js&"
export * from "./pay-weixin-modal.vue?vue&type=script&lang=js&"
import style0 from "./pay-weixin-modal.vue?vue&type=style&index=0&id=af5899c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5899c6",
  null
  
)

export default component.exports